import angular from 'angular';
import { UFaIconComponent } from '@updater/angular-common';
import { UCloudinaryImageDirectives } from '../cloudinary-image';
import { GoogleStarsComponent } from './google-stars.component';

export const GoogleStarsModule = angular
  .module('upd.google-stars', [
    UCloudinaryImageDirectives.name,
    UFaIconComponent.name,
  ])
  .component('updGoogleStars', GoogleStarsComponent);
